import Image from "next/image";
import { RenderSlideProps, Slide, isImageSlide } from "yet-another-react-lightbox";

export default function NextJsImage({ slide, rect, offset: _offset }: RenderSlideProps<Slide>) {
  if (!isImageSlide(slide)) return undefined;

  const { src, alt, width, height } = slide;

  const widthInt = width ? Math.round(width) : undefined;
  const heightInt = height ? Math.round(height) : undefined;

  const imageWidth = rect.width;
  const imageHeight = widthInt && heightInt
    ? (rect.width / widthInt) * heightInt
    : rect.height;

  // Ensure consistent aspect ratio if dimensions provided
  const style: React.CSSProperties = {
    position: "relative",
    width: Math.min(imageWidth, rect.width),
    height: Math.min(imageHeight, rect.height),
    maxWidth: "100%",
    maxHeight: "100%",
  };

  return (
    <div style={style}>
      <Image
        fill
        alt={alt || ""}
        src={src}
        loading="eager"
        draggable={false}
        style={{
          objectFit: "contain",
          width: "100%",
          height: "100%"
        }}
        sizes={`${Math.ceil((widthInt || 0) / window.innerWidth * 100)}vw`}
        unoptimized
      />
    </div>
  );
}
